/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LabReportUploadRequest } from '../models/LabReportUploadRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LabReportControllerService {

    /**
     * Upload lab report files
     * Uploads lab report files and creates a Zendesk ticket with appropriate tags based on file types and provider
     * @param requestBody
     * @returns string Lab report uploaded successfully
     * @throws ApiError
     */
    public static uploadLabReport(
        requestBody: LabReportUploadRequest,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/labs/report',
            body: requestBody,
            mediaType: 'application/json',
            responseHeader: 'X-NineamHealth-TraceId',
            errors: {
                400: `Bad Request`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `One or more files were not found`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
